module.exports = ".chart {\n  width: 100%;\n  min-height: 450px; }\n"